<template>
    <SimpleTable formclass="pages/Point/form" endpoint="api/v2/point" inlineToggle :aditionalColumns="headers">
        <template v-slot="data">
            <h1>Pontos do mapa</h1>
            <v-divider class="mb-4" />
            <v-alert icon="menu_book" prominent text type="info">
                Cadastro de pontos para serem exibidos na tela inicial do aplicativo. Mesmo sem carregador associado o ponto será mostrado.
            </v-alert>
            <v-divider class="mb-4" />
            <v-layout wrap class="my-12">
                <v-flex xs12 sm6>
                    <v-card color="primary">
                        <v-card-text class="white--text">
                            <div class="headline mb-2">
                                <v-icon dark>functions</v-icon>
                                {{ total(data.items) }}
                            </div>
                            Cadastrados
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm6>
                    <v-card color="primary">
                        <v-card-text class="white--text">
                            <div class="headline mb-2">
                                <v-icon dark>functions</v-icon>
                                {{ active(data.items) }}
                            </div>
                            Ativos
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </template>
    </SimpleTable>
</template>

<script>
import SimpleTable from "@/components/core/SimpleTable";

export default {
    components: { SimpleTable },

    data() {
        return {
            headers: [
                { text: this.$t("Ponto no mapa"), value: "enable", align: "right", sortable: false },
                { text: "Endereço", value: "address", align: "right", sortable: true },
                { text: "Descrição", value: "description", align: "right", sortable: true },
                { text: "Nome", value: "name", align: "right", sortable: true },
            ],
        };
    },

    methods: {
        total(items) {
            return Number.parseFloat(items.length).toFixed(0);
        },
        active(items) {
            return Number.parseFloat(items.reduce((sum, i) => (i.enable ? sum + 1 : sum), 0)).toFixed(0);
        },
    },
};
</script>